export const getMessSample = (data) => {
    return {
        type: 'MESS_SAMPLE',
        payload: data
    }
}